import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  root: {
    width: '100%',
    paddingVertical: UNIT * 0.3125
  },
  tableHeader: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight,
    minWidth: UNIT * 9
  },
  icon: {
    fontSize: UNIT * 1.5,
    color: mainColor.colorBlack
  },
  tableRow: {
    fontSize: UNIT * 0.9375,
    minWidth: UNIT * 14,
    width: '25%',
    wordBreak: 'break-all'
  },
  progress: {
    textAlign: 'center',
    color: mainColor.secondaryColor
  },
  typoDetails: {
    fontSize: UNIT * 0.75,
    color: mainColor.colorBlack,
    display: 'inline-block'
  },
  orderDetail: {
    color: mainColor.colorBlack,
    fontSize: UNIT * 0.875
  },
  svg: {
    padding: UNIT * 0.625
  },
  heading: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight
  }
});
